module.exports = __webpack_public_path__ + "static/OneDot-Light.79a52e24.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDot-Light.woff2
// module id = 734
// module chunks = 114276838955818